import axios from "axios";
import ToastContextExports from "../context/ToastContext.tsx";
import { ERROR_MESSAGES_MAP } from "./constants/message-erros.ts";

const progamersApi = axios.create({
  baseURL: import.meta.env.VITE_SOME_API_URL,
});

progamersApi.interceptors.request.use((request) => {
  const token = localStorage.getItem("progamers.token");

  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
});

// @ts-ignore
const ToastInterceptorProvider = ({ children }) => {
  const { showToast } = ToastContextExports.useToast();

  progamersApi.interceptors.response.use(
    (response) => response,
    (error) => {
      let message =
        error.response?.data?.message || error.message || "Ocorreu um erro";
      let shouldShowToast = false;

      // Handle network errors (no response from server)
      if (!error.response) {
        if (error.message === "Network Error") {
          message = "Problema de conexão. Verifique sua internet.";
          shouldShowToast = true;
        }
      }

      if (Array.isArray(error.response?.data?.message)) {
        message = error.response.data.message[0];
      }

      const statusCode =
        error.response?.status || error.response?.statusCode || 0;

      // Handle specific HTTP status codes
      if (statusCode) {
        switch (error.response.status) {
          // Always show service unavailable errors
          case 503:
            message = "Tivemos um problema. Contate o suporte.";
            shouldShowToast = true;
            break;

          // Always show authentication errors
          case 401:
            message = "Não Autenticado";
            localStorage.removeItem("progmers.token");
            shouldShowToast = true;
            break;

          // Show bad request errors if they might be user-actionable
          case 400:
            // Only show if it's likely a validation error the user can fix
            if (message.includes("must be") || message.includes("invalid")) {
              shouldShowToast = true;
            }
            break;

          // Show forbidden errors
          case 403:
            message = "Você não tem permissão para realizar esta ação";
            shouldShowToast = true;
            break;

          // Show not found errors for resources the user requested
          case 404:
            if (
              message.includes("not found") ||
              message.includes("não encontrado")
            ) {
              shouldShowToast = true;
            }
            break;

          case 500:
            shouldShowToast = false;

            break;

          default:
            shouldShowToast = false;
            break;
        }
      }

      // Check if the error message is in our map of user-friendly messages
      const mappedMessage = ERROR_MESSAGES_MAP[message];
      if (mappedMessage) {
        message = mappedMessage;
        shouldShowToast = true;
      }

      // Only show toast for errors that are relevant to the user
      if (shouldShowToast) {
        showToast("Erro", message, "error");
      } else {
        // Log other errors to console for debugging
        console.error("API Error (not shown to user):", error);
      }

      return Promise.reject(new Error(message));
    }
  );

  return children;
};

export { progamersApi, ToastInterceptorProvider };
